import { SVGProps } from 'react'

export const User = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="none" viewBox="0 0 40 40" {...props}>
    <rect width="40" height="40" fill="currentColor" fillOpacity="0.2" rx="20"></rect>
    <path
      fill="currentColor"
      fillOpacity="0.2"
      fillRule="evenodd"
      d="M26 16a6 6 0 11-12 0 6 6 0 0112 0zm-2 0a4 4 0 11-8 0 4 4 0 018 0z"
      clipRule="evenodd"
    ></path>
    <path
      fill="currentColor"
      fillOpacity="0.2"
      d="M20 25c-6.474 0-11.99 3.828-14.092 9.192.512.508 1.051.99 1.616 1.44C9.088 30.708 13.997 27 20 27c6.003 0 10.912 3.708 12.477 8.632.564-.45 1.103-.932 1.615-1.44C31.991 28.828 26.475 25 20 25z"
    ></path>
  </svg>
)
